import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthorizationData } from '@kaseya-shared';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { TotpRequest } from '@core/authorization/models/totp-request.interface';
import { useMfaToken } from '@core/authorization/models/mfa-token-context';

@Injectable({
  providedIn: 'root',
})
export class TotpMfaVerificationService {
  private readonly httpClient = inject(HttpClient);
  private readonly verifyTotpMfaUrl = 'api/v3/totp';

  verifyTotpMfa(totpRequest: TotpRequest, mfaToken: string): Observable<AuthorizationData> {
    return this.httpClient.post<AuthorizationData>(environment.portalApiUrl + this.verifyTotpMfaUrl, totpRequest, {
      context: useMfaToken(mfaToken),
    });
  }
}
